import React, { useEffect, useMemo, useRef, useState } from 'react';
import IconTiempo from '../icons/IconTiempo';
import IconPodium from '../icons/IconPodium';
import IconDonut from '../icons/IconDonut';
import IconMap from '../icons/IconMap';
import IconNotificarOn from '../icons/IconNotificarOn';
import IconCrown from '../icons/IconCrown';

const ResultadoDetailMenu = (props) => {
  const containerRef = useRef(null);
  const btnRefs = useRef([]);
  const [pill, setPill] = useState({ left: 0, width: 0, height: 0 });

  const botonSeleccionado = props.botonSeleccionado;
  const onSelectBoton = props.onSelectBoton;

  // Crear array de botones visibles
  const botones = useMemo(() => {
    const items = [
      { id: 1, icon: <IconTiempo />, label: 'PASOS', visible: true },
      { id: 2, icon: <IconPodium />, label: 'PUESTOS', visible: true },
      { id: 3, icon: <IconCrown />, label: 'RANKINGS', visible: props.tieneRankings },
      { id: 4, icon: <IconDonut />, label: 'SECTORES', visible: props.isSectores },
      { id: 5, icon: <IconMap />, label: 'MAPA', visible: props.isMapa },
      { id: 6, icon: <IconNotificarOn fill="white" />, label: 'NOTIFICAC.', visible: props.isNotificaciones }
    ];
    return items.filter(item => item.visible);
  }, [props.tieneRankings, props.isSectores, props.isMapa, props.isNotificaciones]);

  // Encontrar índice del botón seleccionado
  const activeIdx = useMemo(() => {
    return botones.findIndex(btn => btn.id === botonSeleccionado);
  }, [botones, botonSeleccionado]);

  // Recalcular posición del pill
  useEffect(() => {
    const update = () => {
      const container = containerRef.current;
      const btn = btnRefs.current[activeIdx];
      if (!container || !btn) return;
      const c = container.getBoundingClientRect();
      const b = btn.getBoundingClientRect();
      setPill({
        left: b.left - c.left,
        width: b.width,
        height: b.height
      });
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [activeIdx]);

  return (
    <div className="w-full mb-6">
      <div className="mx-auto max-w-5xl px-4 md:px-40">
        <div className="flex justify-center">
          <div
            ref={containerRef}
            className="relative flex items-center gap-2 rounded-xl ring-1 ring-white/10 px-2 py-2 bg-slate-900/50"
          >
            {/* Píldora animada */}
            <span
              aria-hidden
              className="absolute rounded-lg bg-ccnorte transition-all duration-300 ease-out"
              style={{
                left: pill.left,
                width: pill.width,
                height: pill.height
              }}
            />

            {/* Botones */}
            {botones.map((boton, index) => (
              <button
                key={boton.id}
                ref={(el) => (btnRefs.current[index] = el)}
                onClick={() => onSelectBoton(boton.id)}
                className={[
                  'relative z-10 flex flex-col items-center gap-1 px-4 py-2 rounded-lg font-montserrat text-xs uppercase tracking-wide',
                  'cursor-pointer transition-colors duration-200',
                  botonSeleccionado === boton.id ? 'text-white' : 'text-slate-400 hover:text-slate-300'
                ].join(' ')}
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  {boton.icon}
                </div>
                <span className="text-[10px] font-medium whitespace-nowrap">
                  {boton.label}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultadoDetailMenu;